"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.villageUnresolved = exports.activityNotAccessible = exports.TOOL_ERROR = exports.CONTEXT_ERROR = void 0;
const result_1 = require("./result");
const TOOL_ERROR = {
    TOOL_TIMEOUT: 'TOOL_TIMEOUT',
    TOOL_FAILED: 'TOOL_FAILED',
    TOOL_NOT_AUTHORIZED: 'TOOL_NOT_AUTHORIZED',
    TOOL_NOT_REGISTERED: 'TOOL_NOT_REGISTERED',
};
exports.TOOL_ERROR = TOOL_ERROR;
const CONTEXT_ERROR = {
    VILLAGE_UNRESOLVED: 'VILLAGE_UNRESOLVED',
    ACTIVITY_NOT_ACCESSIBLE: 'ACTIVITY_NOT_ACCESSIBLE',
};
exports.CONTEXT_ERROR = CONTEXT_ERROR;
const villageUnresolved = (consequence) => (0, result_1.toolFailure)(CONTEXT_ERROR.VILLAGE_UNRESOLVED, `目前無法確認登入身分的資料範圍，因此${consequence}。請重新登入後再試一次。`);
exports.villageUnresolved = villageUnresolved;
const activityNotAccessible = (message) => (0, result_1.toolFailure)(CONTEXT_ERROR.ACTIVITY_NOT_ACCESSIBLE, message);
exports.activityNotAccessible = activityNotAccessible;
//# sourceMappingURL=errors.js.map